module.exports = __webpack_public_path__ + "static/media/google-play.266bf100.png";